import { IsNotEmpty, ValidateIf } from 'class-validator';

export class ExerciseFormDataUpdate {
    @IsNotEmpty()
    nameEdit: string;
    
    urlEdit: string;
    
    @IsNotEmpty()
    groupEdit: string;
}
